module.exports = __webpack_public_path__ + "img/logo2_new.6b4df3dc.png";